module.exports = __webpack_public_path__ + "img/IMMERSE_FX_LOGO_WHITE.133f19f2.svg";